export default {"src":"/_next/static/media/apple.760b0b98.svg","height":48,"width":40,"blurWidth":0,"blurHeight":0};